{
  "screen": {
    "overline": "NUESTROS GUÍAS",
    "title": "Conoce a Tus",
    "titleHighlight": "Maestros",
    "subtitle": "Practicantes experimentados dedicados a guiarte en tu camino de crecimiento y autodescubrimiento.",
    "searchPlaceholder": "Buscar por nombre o práctica...",
    "loading": "Sincronizando expertos...",
    "retryConnection": "REINTENTAR CONEXIÓN",
    "noResults": "Sin Resultados",
    "comingSoon": "Próximamente",
    "noResultsHint": "Intenta buscar con una palabra clave diferente.",
    "comingSoonHint": "Actualmente estamos incorporando nuevos maestros.",
    "viewJourney": "VER CAMINO"
  },
  "specialties": {
    "all": "Todos",
    "yogaMovement": "Yoga y Movimiento",
    "meditation": "Meditación",
    "buddhism": "Budismo",
    "shaivism": "Shivaísmo",
    "psychology": "Psicología",
    "wellness": "Bienestar",
    "breathwork": "Respiración"
  },
  "detail": {
    "follow": "SEGUIR",
    "following": "SIGUIENDO",
    "allMasters": "TODOS LOS MAESTROS",
    "masterProfile": "PERFIL DEL MAESTRO",
    "defaultTagline": "Yoga y Meditación · Respiración · Mindfulness",
    "overview": "Descripción General",
    "content": "Contenido",
    "community": "Comunidad",
    "events": "Eventos",
    "all": "Todo",
    "upcomingLives": "Próximas Sesiones en Vivo",
    "pastLives": "Sesiones en Vivo Pasadas",
    "videoPractices": "Prácticas en Video",
    "noContentAll": "No hay contenido disponible en este momento.",
    "noContentUpcoming": "No hay sesiones en vivo programadas próximamente.",
    "noContentPast": "No hay grabaciones pasadas disponibles.",
    "noContentVideos": "Aún no se han publicado prácticas en video.",
    "recording": "GRABACIÓN",
    "video": "VIDEO",
    "practice": "Práctica",
    "messageMaster": "Mensaje al Maestro",
    "messageIntro": "¡Hola! Me gustaría saber más sobre {{title}}...",
    "about": "Acerca de",
    "masterBio": "Bio del Maestro",
    "manifesto": "Manifiesto",
    "upcomingSessions": "Próximas Sesiones",
    "liveStreamsByMaster": "Sesiones en vivo y eventos de {{name}}",
    "noUpcomingSessions": "No hay sesiones próximas en este momento.",
    "viewAllSessions": "VER TODAS LAS SESIONES",
    "couldntLoadContent": "No se pudo cargar el contenido.",
    "upcomingEvents": "Próximos Eventos",
    "retreatsAndGatherings": "Retiros, talleres y encuentros de {{name}}",
    "noUpcomingEvents": "No hay eventos próximos en este momento.",
    "getNotified": "Recibe notificaciones sobre las próximas sesiones de {{name}}",
    "defaultBio": "Un practicante dedicado que comparte el camino del crecimiento interior y la vida consciente.",
    "masterNotFound": "Maestro no encontrado",
    "welcomeTo": "Bienvenido a  {{name}}",
    "followers": "Seguidores",
    "videos": "Videos",
    "lives": "Sesiones en vivo",
    "pushOn": "Notificaciones activadas",
    "pushOff": "Notificaciones desactivadas",
    "addToCal": "Agregar al Cal",
    "aboutThisEvent": "SOBRE ESTE EVENTO",
    "contact": "CONTACTO",
    "filled": "lleno",
    "register": "REGISTRARSE",
    "message": "MENSAJE",
    "messageSent": "Mensaje enviado.",
    "messageDelivered": "Tu mensaje ha sido entregado a {{name}}. Responderán en breve.",
    "yourName": "TU NOMBRE *",
    "enterYourName": "Ingresa tu nombre",
    "yourEmail": "TU EMAIL",
    "emailPlaceholder": "tu@email.com",
    "messageFieldLabel": "MENSAJE *",
    "sendMessage": "ENVIAR MENSAJE",
    "orEmailDirectly": "O escribe directamente a:",
    "fillNameAndMessage": "Por favor completa tu nombre y mensaje",
    "spotsLeft": "{{left}} / {{total}} lugares disponibles",
    "unlimitedSpots": "Lugares ilimitados",
    "subscribe": "SUSCRIBIRSE",
    "retry": "REINTENTAR",
    "online": "EN LÍNEA",
    "offline": "DESCONECTADO",
    "live": "EN VIVO",
    "about_": "Sobre:",
    "questionAbout": "Pregunta sobre: {{title}}"
  },
  "eventTypes": {
    "retreat": "RETIRO",
    "workshop": "TALLER",
    "ceremony": "CEREMONIA",
    "class": "CLASE",
    "festival": "FESTIVAL"
  },
  "calendar": {
    "mon": "LUN",
    "tue": "MAR",
    "wed": "MIÉ",
    "thu": "JUE",
    "fri": "VIE",
    "sat": "SÁB",
    "sun": "DOM",
    "todaysSchedule": "Horario de Hoy",
    "noEventsThisDay": "No hay eventos este día"
  },
  "categories": {
    "mindfulness": "Mindfulness",
    "yoga": "Yoga",
    "breathwork": "Respiración",
    "meditation": "Meditación"
  },
  "native": {
    "title": "Maestros",
    "subtitle": "Encuentra maestros y personas\nque resuenan con tu camino.",
    "empty": "No se encontró a nadie",
    "searchA11y": "Buscar",
    "filtersA11y": "Filtros",
    "mySubscriptions": "Mis suscripciones",
    "all": "Todos"
  }
}